import { ReactNode } from 'react';
import classnames from 'classnames';

type Orientation = 'row' | 'column';

interface Props {
  children: ReactNode;
  orientation: Orientation;
}

const RecordRow = ({ children, orientation }: Props) => {
  const className = classnames({
    flex: true,
    'flex-1': true,
    'list-none': true,
    'justify-around': true,
    'flex-row': orientation === 'row',
    'flex-col': orientation === 'column',
  });

  return <ul className={className}>{children}</ul>;
};

export default RecordRow;
